import React, {Component} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import _ from "lodash";
import PresentationTypeInput from "./components/PresentationTypeInput";
import PresentationTypeSlider from "./components/PresentationTypeSlider";

class Numeric extends Component {

  constructor(props){
    super(props);

    this.onDetailChange = this.onDetailChange.bind(this);
    this.presentationComponent = this.presentationComponent.bind(this);
  }

  onDetailChange(detail){
    this.props.onDetailsUpdated([detail]);

    let value1 = detail.value1;
    let value2 = detail.value2;

    this.props.question.javascripts.map(javascript => {
      if(javascript.action === 'onValueChange'){
        let func = new Function("return " + "function (value1, value2) { " + javascript.code + " }")().bind(this);
        func(value1, value2);
      }
    });
  }

  presentationComponent(){
    const {question, details, validate} = this.props;
    const detail = details[0] || {
      value1: null,
      value2: null
    };

    const defaultProps = {
      detail: detail,
      question,
      onDetailUpdated: (detail) => this.onDetailChange(detail),
      validate: validate
    };

    switch (question.presentationType) {
      case 'input':
        return <PresentationTypeInput {...defaultProps}/>;
      case 'slider':
        return <PresentationTypeSlider {...defaultProps}/>;
      default:
        return <p>{question.presentationType}</p>;
    }
  }

  validate(){
    const {question, details, validationTexts} = this.props;

    let validate = {
      valid: true,
      errors: []
    };

    if(question.required && _.isEmpty(details)){
      validate.errors.push(validationTexts.required)
    }

    if(!_.isEmpty(details)){
      const detail = details[0];

      let valueMin = question.valueMin * Math.pow(10, question.decimals);
      let valueMax = question.valueMax * Math.pow(10, question.decimals);

      if(detail.value1 < valueMin){
        validate.errors.push(validationTexts.detail.valueMin)
      }

      if(valueMax && detail.value1 > valueMax){
        validate.errors.push(validationTexts.detail.valueMax)
      }
    }

    validate.valid = _.isEmpty(validate.errors);
    return validate;
  }

  render() {
    return this.presentationComponent()
  }
}

Numeric.propTypes = {
  question: PropTypes.shape({
    presentationType: PropTypes.oneOf(['input', 'slider']).isRequired,
    required: PropTypes.bool.isRequired,
    valueText: PropTypes.string,
    valueMin: PropTypes.number.isRequired,
    valueMax: PropTypes.number.isRequired,
  }).isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    value1: PropTypes.number,
    value2: PropTypes.number,
    microTime: PropTypes.number,
  }).isRequired),
  id: PropTypes.number.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  validationTexts: PropTypes.shape({
    required: PropTypes.string,
    detail: PropTypes.shape({
      valueMin: PropTypes.string.isRequired,
      valueMax: PropTypes.string.isRequired,
    }).isRequired,
  }),
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
}, null, null, {withRef: true, forwardRef: true})(Numeric);